// extracted by mini-css-extract-plugin
export default {"cardPago":"SeleccionarTipoPagoComponent_cardPago__TPn2-"};